import { selectApiData } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import {
  EmailDistributionModel,
  mapEmailDistributionDtoToModel,
} from './dto/EmailDistribution.dto';

export class EmailDistributionApi {
  constructor(private client: AxiosInstance) {}

  get(projectId: number): Promise<EmailDistributionModel> {
    return this.client
      .get(`/api/v1/project/${projectId}/email-distribution`)
      .then(selectApiData)
      .then(mapEmailDistributionDtoToModel);
  }

  test({
    distributionId,
    to,
    content,
    fromName,
    subject,
  }: {
    distributionId: string;
    to: string[];
    content: string;
    fromName: string;
    subject?: string;
  }): Promise<any> {
    return this.client.post(`/api/v1/distribution/${distributionId}/test`, {
      to,
      content,
      fromName,
      subject,
    });
  }
}
